import React from 'react';
import { Platform, View, Text } from 'react-native';
import { iOSUIKit, material, webWeights } from 'react-native-typography';
import mergeStyles from '../../util/mergeStyles';
function parseTypeSize(props) {
    const [typeSize] = Object
        .keys(props)
        .filter(key => key.match(/h[0-9]/))
        .sort((a, b) => a.localeCompare(b));
    return typeSize;
}
const iOSUIKitMap = {
    h1: 'largeTitleEmphasizedObject',
    h2: 'title3EmphasizedObject',
    h3: 'title3Object',
    h4: 'bodyEmphasizedObject',
    h5: 'bodyObject',
};
const materialMap = {
    h1: 'display3Object',
    h2: 'display2Object',
    h4: 'display1Object',
    h3: 'headlineObject',
    h5: 'headlineObject',
};
const Heading = (props) => {
    const { children, center } = props;
    const typeSize = parseTypeSize(props);
    const mappedType = Platform.OS === 'web'
        ? material[materialMap[typeSize]]
        : iOSUIKit[iOSUIKitMap[typeSize]];
    const styles = mergeStyles(props, mappedType, webWeights.heavy, { color: 'black' }, [{ textAlign: 'center' }, center]);
    return (<View>
      <Text style={styles}>
        {children}
      </Text>
    </View>);
};
export default Heading;
//# sourceMappingURL=Heading.js.map